module.exports = __webpack_public_path__ + "img/coupons_icon_used_en.f3c4883c.png";